export default ["Cringe", "Cute", "Funny", "Heartwarming", "Sad", "Scary"];
